import { ComponentType, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { BaseComponent } from '@portal-shared/app/components/base-components/base.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService extends BaseComponent {
  private overlayRef?: OverlayRef;

  public constructor(private overlay: Overlay) {
    super();
  }

  public openModal<T>(component: ComponentType<T>, init?: (_: T) => void, closeOnBackdropClick = true) {
    const overlayConfig = this.overlay.position().global().centerHorizontally().centerVertically();

    if (!this.overlayRef) {
      this.overlayRef = this.overlay.create({
        positionStrategy: overlayConfig,
        hasBackdrop: true
      });
      this.overlayRef?.outsidePointerEvents();

      if (closeOnBackdropClick) {
        this.subscribe(this.overlayRef.backdropClick().subscribe(() => this.closeModal()));
      }
    }

    this.closeModal();

    const modal = new ComponentPortal(component);

    const modalComponent = this.overlayRef.attach(modal);
    if (init) {
      init(modalComponent.instance);
    }
    return modalComponent.instance;
  }

  public closeModal() {
    this.overlayRef?.detach();
  }
}
